import { ShieldX } from "lucide-react";
import { Link } from "react-router-dom";

export function AccessDeniedPage() {
  return <section className="empty-state"><ShieldX /><span className="eyebrow">Access denied</span><h1>This page is outside your authorized access.</h1><p>RBIM checks both your permission and assigned geographic coverage. Contact your LGU System Administrator if your assignment is incorrect.</p><Link className="primary-button" to="/">Return to dashboard</Link></section>;
}

